import React from "react"
import { PrismicImageType } from "types/__generated__/gatsby-graphql"

import { Element, ElementProps, Image } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"

interface OwnProps {
  alignment: ElementProps["textAlign"]
  bgColor?: string | null
  imageData: Maybe<PrismicImageType>
  small_image: Maybe<boolean>
}

export type ColumnImageProps = OwnProps

const ColumnImage: React.FC<ColumnImageProps> = ({
  bgColor = "white",
  alignment,
  imageData,
  small_image,
}): React.ReactElement | null => {
  if (!imageData?.alt || !imageData?.url) return null

  const maxWidth = small_image ? "150px" : "100%"
  const { height, width } = imageData?.dimensions || {}

  return (
    <Element
      bg={bgColor}
      display="block"
      justifyContent="flex-start"
      mb={["20px", "50px"]}
    >
      <Element fontSize={0} textAlign={alignment}>
        <Image
          aspectRatio={`${width} / ${height}`}
          fontSize={["12", "text.body"]}
          imageData={imageData}
          width={small_image ? "150px" : width}
          maxWidth={maxWidth}
        />
      </Element>
    </Element>
  )
}

export default ColumnImage
